import { render, staticRenderFns } from "./TranslationPreviewPane.vue?vue&type=template&id=3259b46a&"
import script from "./TranslationPreviewPane.vue?vue&type=script&lang=js&"
export * from "./TranslationPreviewPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports